import { toast } from 'react-toastify'
import _ from 'underscore'

export const getErrorText = (error) =>
  _.isString(error)
    ? error
    : error.response?.data?.status?.message || error?.message || 'Unexpected Error'

export const getErrorStatusCode = (error) =>
  error.response?.data?.status?.code || error.response?.status || 500

export const throwError = (errorMsg) => {
  toast.error(errorMsg)
  throw Error(errorMsg)
}
